import { __assign } from "tslib";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { intervalToDuration } from 'date-fns';
import cx from 'classnames';
import bcx from 'bem-classname';
import { Clock } from '../icons';
export function CountdownV2(props) {
    var _a, _b;
    var componentClass = 'countdown';
    var labels = props.labels, className = props.className, _c = props.showSeconds, showSeconds = _c === void 0 ? true : _c, _d = props.onMounted, onMounted = _d === void 0 ? null : _d, _e = props.unstyled, unstyled = _e === void 0 ? false : _e;
    var _f = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    }), state = _f[0], setState = _f[1];
    var interval = useRef(null);
    var classes = cx((_a = {}, _a[componentClass] = !unstyled, _a), className);
    var totalSeconds = useMemo(function () {
        return Math.ceil((new Date(props.limitDate).getTime() - new Date(props.startDate).getTime()) / 1000);
    }, [props.limitDate]);
    var _g = useState(0), timeLeft = _g[0], setTimeLeft = _g[1];
    var _h = useState('few'), timeClass = _h[0], setTimeClass = _h[1];
    var _j = useState(false), mounted = _j[0], setMounted = _j[1];
    var timeLimits = useMemo(function () { return ({
        total: totalSeconds,
        half: totalSeconds / 2,
        few: totalSeconds / 4,
    }); }, [totalSeconds]);
    useEffect(function () {
        if (totalSeconds >= timeLeft && timeLeft > timeLimits.half && timeClass !== 'total') {
            setTimeClass('total');
            return;
        }
        if (timeLimits.half >= timeLeft && timeLeft > timeLimits.few && timeClass !== 'half') {
            setTimeClass('half');
            return;
        }
        if ((timeLimits.few >= timeLeft || timeLeft === 0) && timeClass !== 'few') {
            setTimeClass('few');
        }
    }, [timeLeft]);
    function calculateCountdown(limitDate) {
        if (!limitDate)
            return false;
        setTimeLeft(Math.ceil((new Date(limitDate).getTime() - new Date().getTime()) / 1000));
        var duration = intervalToDuration({
            start: new Date(),
            end: new Date(limitDate),
        });
        return duration;
    }
    function hasFinished(interval) {
        var days = interval.days, hours = interval.hours, minutes = interval.minutes, seconds = interval.seconds;
        return !days && !hours && !minutes && !seconds;
    }
    function addLeadingZeros(value) {
        return String(value || '').padStart(2, '0');
    }
    function stop() {
        if (interval.current)
            clearInterval(interval.current);
    }
    function start() {
        interval.current = setInterval(function () {
            var interval = props.limitDate ? calculateCountdown(props.limitDate.toString()) : null;
            if (interval && !hasFinished(interval)) {
                var _a = interval.days, days_1 = _a === void 0 ? 0 : _a, _b = interval.hours, hours_1 = _b === void 0 ? 0 : _b, _c = interval.minutes, minutes_1 = _c === void 0 ? 0 : _c, _d = interval.seconds, seconds_1 = _d === void 0 ? 0 : _d;
                setState(function (prev) { return (__assign(__assign({}, prev), { days: days_1, hours: hours_1, minutes: minutes_1, seconds: seconds_1 })); });
            }
            else {
                setState(function (prev) { return (__assign(__assign({}, prev), { days: 0, hours: 0, minutes: 0, seconds: 0 })); });
                stop();
            }
        }, 1000);
    }
    useEffect(function () {
        start();
        return function () { return stop(); };
    }, [props]);
    function getCount() {
        var count = '';
        if (state.days) {
            count = "".concat(addLeadingZeros(state.days), " ").concat((labels === null || labels === void 0 ? void 0 : labels.days) || 'ds', " ");
        }
        if (state.hours) {
            count = "".concat(count).concat(addLeadingZeros(state.hours), ":");
        }
        if (state.minutes || state.hours) {
            count = count
                ? "".concat(count).concat(addLeadingZeros(state.minutes))
                : "".concat(addLeadingZeros(state.minutes));
        }
        if ((state.seconds || state.minutes || state.hours) && showSeconds) {
            count = count
                ? "".concat(count, ":").concat(addLeadingZeros(state.seconds))
                : "00:".concat(addLeadingZeros(state.seconds));
        }
        if (count !== '' && mounted === false) {
            setMounted(true);
        }
        return "".concat(count || '00:00');
    }
    useEffect(function () {
        if (mounted && onMounted !== null) {
            onMounted();
        }
    }, [mounted, onMounted]);
    return (React.createElement("span", { className: cx(bcx(classes, (_b = {}, _b[timeClass] = true, _b)), { 'd-none': !mounted }) },
        !unstyled && React.createElement(Clock, { size: "16", className: "mr-2" }),
        React.createElement("span", null, getCount())));
}
//# sourceMappingURL=CountdownV2.js.map